import Swiper from 'swiper/bundle';
import ContentSuggestions from "./ContentSuggestions/ContentSuggestions";
import CounterPageSelection from "./CounterPageSelection/CounterPageSelection";
import ImageLightbox from "./ImageLightbox/ImageLightbox";

// typewriter instanz
let aw = undefined;
const mediaQueryDeviceS = window.matchMedia('(max-width:1023px)');
const mediaQueryDeviceXS = window.matchMedia('(max-width:750px)');

/***************************************************************************
 ** toggle navigation
 */

function toggleNavigation(){
  if($('html').hasClass('nav-overlay-open')){
    setTimeout(function (){
      $('html').removeClass('nav-overlay-open');
    }, 50)
  } else {
    $('html').addClass('nav-overlay-open');
  }
  let navContainer = $('.js-nav-container');
  if(navContainer.hasClass('open-level-2')){
    navContainer.removeClass('open-level-2');
    $('.js-nav-level-1').addClass('active');
  } else {
    navContainer.toggleClass('open-level-1');
  }
}

/***************************************************************************
 ** tab navigation search default
 */
function checkSearchLocation () {
  if($('.js-switch-search.active').length > 0) {
    const _suggestion = $('.js-switch-search.active').attr('data-id');
    $('.js-search-suggest').addClass('hide');
    $("[data-suggestion='"+_suggestion+"']").removeClass('hide');
  }
  if($('.js-search--compact-child.active').length > 0) {
    const _suggestion = $('.js-search--compact-child.active').attr('data-id');
    $('.js-search-suggest').addClass('hide');
    $("[data-suggestion='"+_suggestion+"']").removeClass('hide');
  }
}

// mobile Safari reports wrong values on offset()
if ( /webkit.*mobile/i.test(navigator.userAgent)) {
  (function($) {
    $.fn.offsetOld = $.fn.offset;
    $.fn.offset = function() {
      var result = this.offsetOld();
      result.top -= window.scrollY || 0;
      result.left -= window.scrollX || 0;
      return result;
    };
  })(jQuery);
}

/***************************************************************************
 ** extended search suggestion
 */
function toggleExtendedSuggestion(el, toggleBtn){
  var parentEl = $(el).closest('.js-search-suggest-wrap');

  if(toggleBtn){
    parentEl.find('.js-search-suggest-less, .js-search-suggest-more').toggleClass('hidden');
    if(parentEl.find('.js-search-suggest-more').hasClass('hidden')) {
      openSearchSuggestExtended();
    } else {
      closeSearchSuggestExtended();
    }
  }
  parentEl.find('.js-search-suggest-icon').toggleClass('active');
}

/***************************************************************************
 ** show suggestion on compact search
 */
function setSearchFocus() {
  if($('.js-search-input:not(.hidden) .input').is(':visible')) {
    $('.js-search-input:not(.hidden) .input').focus();
  }
}

function highlightSearchResultTitle() {
  if (document.querySelector('.search-result')) {
    const queryString = window.location.search
    const params = new URLSearchParams(queryString);
    const q = params.get("q");

    const searchResultTitles = document.querySelectorAll('.search-result__title');
    searchResultTitles.forEach(element => {
      const text = element.textContent;
      element.innerHTML = text.replaceAll(q, '<span class="highlight">' + q + '</span>');
    });

    // bonus: populate search field with query string
    const searchInput = document.querySelector('#zhb-compact');
    searchInput.value = q;
  }
}

/***************************************************************************
 ** typewriter on mobile
 */
const animationWorker = function (input, texts) {
  this.input = input;
  this.defaultPlaceholder = this.input.getAttribute('placeholder');
  this.texts = texts;
  this.curTextNum = 0;
  this.curPlaceholder = '';
  this.blinkCounter = 0;
  this.animationFrameId = 0;
  this.animationActive = false;
  this.input.setAttribute('placeholder',this.curPlaceholder);

  this.switch = (timeout) => {
    this.input.classList.add('imitatefocus');
    setTimeout(
      () => {
        this.input.classList.remove('imitatefocus');
        if (this.curTextNum == 0)
          this.input.setAttribute('placeholder',this.defaultPlaceholder);
        else
          this.input.setAttribute('placeholder',this.curPlaceholder);

        setTimeout(
          () => {
            this.input.setAttribute('placeholder',this.curPlaceholder);
            if(this.animationActive)
              this.animationFrameId = window.requestAnimationFrame(this.animate)},
          timeout);
      },
      timeout);
  }

  this.animate = () => {
    if(!this.animationActive) return;
    let curPlaceholderFullText = this.texts[this.curTextNum];
    let timeout = 900;
    if (this.curPlaceholder == curPlaceholderFullText+'|' && this.blinkCounter==3) {
      this.blinkCounter = 0;
      this.curTextNum = (this.curTextNum >= this.texts.length-1)? 0 : this.curTextNum+1;
      this.curPlaceholder = '|';
      this.switch(3000);
      return;
    }
    else if (this.curPlaceholder == curPlaceholderFullText+'|' && this.blinkCounter<3) {
      this.curPlaceholder = curPlaceholderFullText;
      this.blinkCounter++;
    }
    else if (this.curPlaceholder == curPlaceholderFullText && this.blinkCounter<3) {
      this.curPlaceholder = this.curPlaceholder+'|';
    }
    else {
      this.curPlaceholder = curPlaceholderFullText
        .split('')
        .slice(0,this.curPlaceholder.length+1)
        .join('') + '|';
      timeout = 150;
    }
    this.input.setAttribute('placeholder',this.curPlaceholder);
    setTimeout(
      () => { if(this.animationActive) this.animationFrameId = window.requestAnimationFrame(this.animate)},
      timeout);
  }

  this.stop = () => {
    this.animationActive = false;
    window.cancelAnimationFrame(this.animationFrameId);
    return;
  }

  this.start = () => {
    this.animationActive = true;
    this.animationFrameId = window.requestAnimationFrame(this.animate);
    return this;
  }
}


function typewriter(){
  //taken from https://codepen.io/lmoroz/pen/jLMLRE
  if( $('.js-search-on-stage').length > 0) {
    let _this = $('.js-search-on-stage');
    let texts = _this.attr('data-placeholder').split("|");
    let input = _this.find('.js-search-input-zhb .input').get(0);
    if(window.innerWidth < 1024) {
      if(aw === undefined) {
        aw = new animationWorker(input, texts).start();
        input.addEventListener("focus", (e) => aw.stop());
        input.addEventListener("blur", (e) => {
          aw = new animationWorker(input, texts);
          if(e.target.value == '') setTimeout( aw.start, 2000);
        });
      }
    } else {
      if(aw !== undefined) {
        aw.stop();
        aw = undefined;
      }
    }
  }
}

function typewriterReset() {
  if(aw !== undefined) {
    aw.stop();
    aw = undefined;
  }
  let input = $('.js-search-on-stage .js-search-input-zhb .input');
  if(window.innerWidth < 1024) {
    input.attr('placeholder',input.attr('aria-label'));
  }
}


/***************************************************************************
 ** scroll event for search
 */
var dir, st, lastSearchPos;

function resetStickyHeader() {
  let _search = $('.js-search');
  _search.removeClass("search--on-header is-sticky");
  $('html').get(0).style.removeProperty('--header-translate-y');
  if($('.js-search-on-stage').length > 0) {
    openSearchSuggest();
    //typewriter();
  }
}
function setStickyHeader() {
  closeSearchSuggest();
  closeSearchSuggestExtended();
  //typewriterReset();
}

function closeSearchSuggest() {
  $('.js-search-suggest-wrap').stop(true, true).slideUp();
  $('html').removeClass("search-suggest-open");
}
function openSearchSuggest() {
  $('.js-search-suggest-wrap').stop(true, true).slideDown();
  $('html').addClass("search-suggest-open");
}
function closeSearchSuggestExtended() {
  $('.js-search-suggest-extended').stop(true, true).slideUp();
  $('.js-search-suggest-less').addClass('hidden');
  $('.js-search-suggest-more').removeClass('hidden');
  $('html').removeClass("search-suggest-extended-open");
  $('.js-search-suggest-wrap').css('maxHeight','');
}
function openSearchSuggestExtended() {
  $('.js-search-suggest-extended').stop(true, true).slideDown();
  $('.js-search-suggest-less').removeClass('hidden');
  $('.js-search-suggest-more').addClass('hidden');
  $('html').addClass("search-suggest-extended-open");
  st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
  var _positionTop = $('.js-search-suggest-wrap').offset().top - st;
  //var _maxH = window.innerHeight - _positionTop - 20;
  var _maxH = window.innerHeight - _positionTop;
  $('.js-search-suggest-wrap').css('maxHeight',_maxH);
}
function searchOnStagePosInit() {
  if($('.js-search-on-stage').length === 1 && $('html').hasClass('search-suggest-extended-open') === false && window.innerWidth > 1023) {
    let initPos = ($('.js-search-suggest-wrap').outerHeight() + $('.search__form-outerwrap').outerHeight() - 50) * -1 + 'px';
    $('.js-search-on-stage').get(0).style.setProperty('--init-pos', initPos);
  }
}

/***************************************************************************
 ** cards news
 */
function lineclampMobileNewsCard(){
  $('.js-card-news').each(function (){
    if(window.innerWidth < 750){
      var titleEl = $($(this).find('.card__title'));
      var titleHeight = titleEl.height();
      var titleLineHeight = parseInt(titleEl.css('lineHeight'));
      var lines = titleHeight / titleLineHeight;
      switch(Math.round(lines)){
        case 2:
          var lineClamp = '3';
          break;
        case 3:
          lineClamp = '2';
          break;
        case 4:
          lineClamp = '1';
          break;
        default:
          lineClamp = '4';
          break;
      }

      $($(this).find('.card__text')).css('-webkit-line-clamp', lineClamp);
    }
  })
}

/***************************************************************************
 ** get scrollbarWidth
 */

function getScrollbarWidth() {
  let div = document.createElement('div');

  div.style.overflowY = 'scroll';
  div.style.width = '50px';
  div.style.height = '50px';

  // must put it in the document, otherwise sizes will be 0
  //mobile return scrollbar with 0. -> this is good so for adjusting body width
  document.body.append(div);
  let scrollWidth = div.offsetWidth - div.clientWidth;
  div.remove();
  $('html').get(0).style.setProperty('--scrollbar-width',scrollWidth + 'px');
}
function scrollbarCheck() {
  let hasScrollBar = $(document).height() > $(window).height();
  if(hasScrollBar) {
    $('html').addClass('body-has-scrollbar');
  } else {
    $('html').removeClass('body-has-scrollbar');
  }
}

/***************************************************************************
 ** search input placeholder update
 */

function updateSearchPlaceholder() {
  $('[data-placeholder-mobile]').each(function (){
    if (mediaQueryDeviceS.matches) {
      if($(this).attr('data-placeholder-desktop') === undefined) {
        $(this).attr('data-placeholder-desktop', $(this).attr('placeholder'));
      }
      $(this).attr('placeholder', $(this).attr('data-placeholder-mobile'));
    } else {
      if($(this).attr('data-placeholder-desktop') !== undefined) {
        $(this).attr('placeholder', $(this).attr('data-placeholder-desktop'));
      }
    }
  })
}

/***************************************************************************
 ** custom-select in news
 */

function updateCustomTextValue(_wrap) {
  let _text = _wrap.find('option:selected').length > 0 ? _wrap.find('option:selected').text() : _wrap.find('option').eq(0).text();
  _wrap.find('.custom-select__value').text(_text);
  if(_wrap.find('option:selected').val() === '') {
    _wrap.removeClass('selected');
  } else {
    _wrap.addClass('selected');
  }

}
function setCustomDropdownNull(_wrap) {
  _wrap.removeClass('selected');
  resetCustomDropdownOptions(_wrap);
  _wrap.find('.js-custom-select-option').eq(0).addClass('selected');
  _wrap.find('.js-custom-select-option').eq(0).attr('aria-selected', true);
}
function resetCustomDropdownOptions(_wrap) {
  _wrap.find('.js-custom-select-option').removeClass('selected');
  _wrap.find('.js-custom-select-option').attr('aria-selected', false);
}

function slideUpCustomSelect(_this) {
  _this.find('.custom-select').attr('aria-expanded', false);
  _this.find('.custom-select__dropdown').stop(true, true).slideUp(function() {
    _this.removeClass('open');
  });
}
function slideDownCustomSelect(_this) {
  _this.find('.custom-select').attr('aria-expanded', true);
  _this.addClass('open');
  _this.find('.custom-select__dropdown').stop(true, true).slideDown();
}
function resetCustomSelect() {
  $('.js-custom-select-wrap').each(function() {
    slideUpCustomSelect($(this));
  });
}

//close dropdown if click outside
document.addEventListener('click', function (e) {
  if (!e.target.closest('.js-custom-select-wrap')) {
    $('.js-custom-select-wrap').each(function () {
      slideUpCustomSelect($(this));
    })
  } else {
    $('.js-custom-select-wrap').each(function () {
      if (e.target.closest('.js-custom-select-wrap') !== this) {
        slideUpCustomSelect($(this));
      }
    })
  }
});

/***************************************************************************
 ** init
 */
function resizeInit() {
  checkSearchLocation();
  //typewriter();
  searchOnStagePosInit();
  resetCustomSelect();
  updateSearchPlaceholder();
}



/***************************************************************************
 Initialization
 /***************************************************************************/

$(function() {
  const $body = $('body');

  /***************************************************************************
   ** open level2 subnavigation
   */
  $('.js-open-nav').on('click', function (){
    toggleNavigation();
  });

  $('.js-nav-overlay').on('click', function (e){
    $(e.target).hasClass('js-nav-overlay') && toggleNavigation();
  })

  /***************************************************************************
   ** open level2 subnavigation
   */
  $('.js-open-level2').on('click', function (e){
    var activeSubmenu = $(this).attr('data-id');
    e.preventDefault();
    if($('.js-nav-level-2.open').length > 0 && $('.js-nav-level-2.open').attr('data-id') != activeSubmenu) {
      $('.js-nav-level-2.open').removeClass('open');
    }

    $('.js-nav-level-2[data-id="' + activeSubmenu + '"]').addClass('open');
    $('.js-nav-container').removeClass('open-level-1').addClass('open-level-2');
    $('.js-nav-level-1').removeClass('active');
  });

  /***************************************************************************
   ** open level1 subnavigation
   */
  $('.js-open-level1').on('click', function (){
    $('.js-nav-container').addClass('open-level-1').removeClass('open-level-2');
    $('.js-nav-level-1').addClass('active');
    $('.js-nav-level-2.open').removeClass('open');
  });

  /***************************************************************************
   ** tab navigation search default
   */
  $('.js-switch-search').on('click', function (){
    // visol change begin
    configureSearchFormForSearchType($(this).data('id'));
    // visol change end

    var parentEl = $(this).closest('.js-search');

    $('.js-switch-search.active').removeClass('active');
    $('.js-search--compact-child.active').removeClass('active');

    $(this).addClass('active');
    $('.js-search--compact-child[data-id="' + $(this).attr('data-id') + '"]').addClass('active');
    checkSearchLocation();

    parentEl.find($('.js-search-input')).addClass('hidden');
    parentEl.find($('.js-search-input[data-id="' + $(this).attr('data-id') + '"]')).removeClass('hidden');

    var inputField = parentEl.find($('.js-search-input[data-id="' + $(this).attr('data-id') + '"] .input'));
    inputField.focus();

    if(parentEl.find($('.js-search-input[data-id="' + $(this).attr('data-id') + '"] .input')).val() != ''){
      $('.js-search-clear').removeClass('hidden');
    } else {
      $('.js-search-clear').addClass('hidden');
    }
  });

  /***************************************************************************
   ** tab navigation search compact
   */
  $('.js-switch-search-compact').on('click', function (){
    var activeEl = $(this).find('.js-search--compact-child:not(.active)');
    // The speaking identifier of the current search type, one of "swisscovery" and "zhb"
    var activeId = activeEl.attr('data-id');
    $('.js-search--compact-child').removeClass('active');
    $('.js-switch-search.active').removeClass('active');

    $('.js-search-suggest[data-suggestion!="'  + activeId + '"]').addClass('hide');
    $('.js-search-suggest[data-suggestion="'  + activeId + '"]').removeClass('hide');

    configureSearchFormForSearchType(activeId);
    closeSearchSuggest();
    closeSearchSuggestExtended();

    $(this).find('.js-search--compact-child[data-id="'  + activeId + '"]').addClass('active');
    $(this).find('.js-search--compact-child[data-id!="'  + activeId + '"]').removeClass('active');

    var parentEl = $(this).closest('.js-search');

    parentEl.find($('.js-search-input[data-id="' + activeId + '"]')).removeClass('hidden');
    parentEl.find($('.js-search-input[data-id!="' + activeId + '"]')).addClass('hidden');

    parentEl.find($('.js-switch-search[data-id="' + activeId + '"]')).addClass('active');
    parentEl.find($('.js-switch-search[data-id!="' + activeId + '"]')).removeClass('active');

    var inputField = parentEl.find($('.js-search-input[data-id="' + activeId + '"] .input'));
    inputField.focus();

    // open search suggestions on switching context if searchbar not in header
    if(!$('.js-search').hasClass('search--on-header')) {
      openSearchSuggest();
    }

  });

  if($('section.search-result[data-search-result-total="0"]').length > 0) {
    $body.addClass('page-broken');
  }

  $body.on('click', '.js-close-extended-suggestion', function () {
    closeSearchSuggestExtended();
  });

  /***************************************************************************
   ** extended search suggestion
   */
  $(document).on('keyup',function(evt) {
    if (evt.keyCode == 27) {
      if($('html').hasClass('search-suggest-extended-open')){
        toggleExtendedSuggestion($('.js-open-extended-suggestion'), true);
      }
    }
  });
  $body.on('click', '.js-open-extended-suggestion', function () {
    toggleExtendedSuggestion($(this), true);
  });
  $body.on('click', '.js-open-extended-suggestion--mobile', function () {
    toggleExtendedSuggestion($(this), true);
  });

  /***************************************************************************
   ** show clear button if search contains something
   */
  $('.js-search-input .input').on('keyup',function() {
    if($(this).val().length > 0 && $('.js-search-clear').hasClass('hidden')){
      $('.js-search-clear').removeClass('hidden');
      $('.search__input-wrap').addClass('visible-clear-btn');
    }

    if($(this).val().length == 0){
      $('.js-search-clear').addClass('hidden');
      $('.search__input-wrap').removeClass('visible-clear-btn');
    }
  });


  /***************************************************************************
   ** clear search
   */

  $('.js-search-clear').on('click', function (e){
    e.preventDefault();
    var searchBox = $(this).closest('.js-search').find('.js-search-input:not(.hidden) .input');
    $(searchBox).val('');
    $(searchBox).focus();
    $('.js-search-clear').addClass('hidden');
  });

  /***************************************************************************
   ** show suggestion on compact search
   */
  $('.js-search-input .input').on('click', function (){
    if(!$('.js-search').hasClass('search--on-header')) {
      openSearchSuggest();
    }
  })

  window.addEventListener('scroll', function(){
    st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

    let headerH = $('.header').outerHeight();
    let triggerPos = 0;
    let _search = $('.js-search');
    let _searchOnHeaderTop = 30;
    if(window.innerWidth < 1024) {
      _searchOnHeaderTop = headerH;
    }
    if(_search.length > 0) {
      if(window.innerWidth >= 1024 || $('.js-search-on-stage').length > 0) {
        let curSearchTop = Math.floor($('.js-search').get(0).getBoundingClientRect().top);

        if(curSearchTop <= _searchOnHeaderTop) {
          _search.addClass("search--on-header is-sticky");
          setStickyHeader();
          $('html').get(0).style.setProperty('--header-translate-y',(headerH * -1) + 'px');
        } else {
          _search.removeClass("is-sticky");
          if($('.js-search-on-stage').length > 0) {
            triggerPos = _search.offset().top - headerH - ($('.search__switcher').height() / 2);
          }

          if(st > triggerPos) {
            _search.addClass("search--on-header");
            $('html').get(0).style.setProperty('--header-translate-y',(triggerPos - st) + 'px');
            setStickyHeader();
          } else {
            resetStickyHeader();
          }
        }
      } else {
        resetStickyHeader();
      }
    }

    const backToTop = $('.js-back-to-top');
    if(backToTop.length > 0){
      if(st > 100) {
        backToTop.removeClass('hide').addClass('visible');
      } else {
        if(backToTop.hasClass('visible')) {
          backToTop.removeClass('visible').addClass('hide');
        }
      }
    }
  }, false);


  $(document).ready(function () {
    highlightSearchResultTitle();
    $(document).click(function (e) {
      var container = $('.js-search');

      if (!container.is(e.target) && !container.has(e.target).length) {
        closeSearchSuggestExtended();
        if($('.js-search-on-stage').length === 0) {
          closeSearchSuggest();
        }
      }
    });
  })

  /***************************************************************************
   ** cards expand/collapse
   */

  $('body').on('click', '.js-card-expand', function (e){
    if(e.target.tagName !== "A") {
      const _content = $(this).find('.js-card-expand-content');
      const _this = $(this);
      if($(this).hasClass('card--open')) {
        _content.stop(true, true).slideUp();
        $(this).removeClass('card--open');
        $('html, body').scrollTop(_this.offset().top - 150); //150 = header + search + space
      } else {
        _content.stop(true, true).slideDown();
        $(this).addClass('card--open');
      }
    }
  });

  /***************************************************************************
   ** card stack slider
   */

  if(window.innerWidth > 750){
    var clickable = true;
  } else {
    clickable = false;
  }

  const swiper = new Swiper('.swiper', {
    // Optional parameters
    loop: true,
    speed: 500,
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true
    },
    autoHeight: true
  });

  if(swiper.length > 0) {
    let delay = 2500;
    Array.prototype.slice.call(swiper).forEach(function (item, index) {
      if(index > 0) {
        item.autoplay.pause();
        setTimeout(function() {
          item.autoplay.start();
        },delay * index);
      }
    });
  }



  /***************************************************************************
   ** accordion
   */
  $('body').on('click', '.accordion__item__header', function() {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
    return false;
  });

  /***************************************************************************
   ** input label animation
   */
//if content set
  $('.js-input-animate .input, .js-textarea-animate .textarea').each(function (){
    if($(this).val() !== '' || $(this).hasClass('input--error')){
      $(this).closest('.js-input-animate, .js-textarea-animate').addClass('active');
    }
  })
  $('.js-input-animate .input, .js-textarea-animate .textarea').on('click, focus', function (){
    $(this).closest('.js-input-animate, .js-textarea-animate').addClass('active');
  });

  $('.js-input-animate .input, .js-textarea-animate .textarea').on('focusout', function (){
    if($(this).val() === '' && !$(this).hasClass('input--error')){
      $(this).closest('.js-input-animate, .js-textarea-animate').removeClass('active');
    }
  });

  /***************************************************************************
   ** select field
   */
  $('.js-select .select:required').each(function (){
    $(this).val() == null && $(this).closest('.js-select').addClass('form--error');
  })

  // keep active, if value is selected
  $('.js-select .select').on('change', function (){
    if($(this).val() != '') {
      $(this).closest('.js-select').addClass('active');
    }
    else {
      $(this).closest('.js-select').removeClass('active');
    }
    $(this).closest('.js-select').hasClass('form--error') && $(this).closest('.js-select').removeClass('form--error');
  });

  // handle enter/leave select field
  $('.js-select .select').on('focus', function (){
    $(this).closest('.js-select').addClass('focus');
  });
  $('.js-select .select').on('blur', function (){
    $(this).closest('.js-select').removeClass('focus');
  });

  $('.checkbox').on('focus', function (){
    $(this).closest('.checkbox-wrap').addClass('focus');
  });
  $('.checkbox').on('blur', function (){
    $(this).closest('.checkbox-wrap').removeClass('focus');
  });

  /***************************************************************************
   ** upload input
   */
  $('.js-upload').on('change',function (event){
    let parentEl = $(this).closest('.field__wrap');
    if(event.target.files.length > 0){
      $('.js-clear-upload').removeClass('hidden');
      $('.js-label-upload').text(event.target.files[0].name);
    }
    else {
      $('.js-label-upload').text($(this).data('default'));
    }
  });

  $('.js-clear-upload').on('click', function (event){
    let parentEl = $(this).closest('.upload');
    // fixme: if field is cleared, validation is not triggered again even with trigger 'change'
    $(parentEl.find('.js-upload')).val('').focus().trigger('change');
    $('.js-clear-upload').addClass('hidden');
    $(parentEl.find('.js-label-upload')).text($(parentEl.find('.js-label-upload')).attr('data-default'))
    event.preventDefault();
  });

  $(window).resize(function(){
    resizeInit();
  })
  /*
  window.addEventListener('orientationchange', function () {
      $('html').addClass('orientation--changed');
  });
  */

  /***************************************************************************
   ** custom-select in news
   */
  $('.js-custom-select-wrap').on('click', function (e){
    if (mediaQueryDeviceXS.matches) {
      slideUpCustomSelect($(this));
    } else {
      if($(this).hasClass('open')) {
        slideUpCustomSelect($(this));
      } else {
        slideDownCustomSelect($(this));
      }
    }
  });

  $body.on('click', '.js-custom-select-option', function (e) {
    let _val = $(this).attr('data-value');
    let _thisWrap = $(this).closest('.js-custom-select-wrap');
    let _thisSelectbox = _thisWrap.find('.custom-select__select');

    if($(this).hasClass('selected')) {
      setCustomDropdownNull(_thisWrap);
      _thisSelectbox.find('option').eq(0).prop('selected', true);
    } else{
      resetCustomDropdownOptions(_thisWrap);
      $(this).addClass('selected');
      $(this).attr('aria-selected', true);
      _thisSelectbox.find('option[value="'+_val+'"]').prop('selected', true);
    }
    updateCustomTextValue(_thisWrap);

    $(this).closest('form').submit();
  });

  $body.on('change', '.js-custom-select', function () {
    let _thisWrap = $(this).closest('.js-custom-select-wrap');

    if($(this).val() === "") {
      setCustomDropdownNull(_thisWrap);
    } else {
      resetCustomDropdownOptions(_thisWrap);
      let _thisDropdownOption =  _thisWrap.find('[data-value="'+$(this).val()+'"]');
      _thisDropdownOption.addClass('selected');
      _thisDropdownOption.attr('aria-selected', true);
    }

    updateCustomTextValue(_thisWrap);

    $(this).closest('form').submit();
  });


});

/**
 * Depending on the clicked search type ("zhb" or "swisscovery"), we need to update the search form's action and target
 */
const searchForm = document.querySelector('.search__form-wrap');

const swisscoverySearchEndpoints = JSON.parse(searchForm.dataset.swisscoverySearchEndpoints);
const currentOrLastSelectedCounterPage = document.body.dataset.counterPage || getCookie('lastSelectedCounterPage') || null;
let swisscoverySearchConfiguration;
if (currentOrLastSelectedCounterPage && swisscoverySearchEndpoints.hasOwnProperty(currentOrLastSelectedCounterPage)) {
  swisscoverySearchConfiguration = swisscoverySearchEndpoints[currentOrLastSelectedCounterPage];
} else {
  swisscoverySearchConfiguration = swisscoverySearchEndpoints['_default'];
}

function configureSearchFormForSearchType(searchType) {
  searchForm.dataset.searchType = searchType;
  if (searchType === 'zhb') {
    searchForm.action = searchForm.dataset.zhbSearchResultsUri;
    searchForm.querySelector('[name="swisscovery__query"]').value = '';
  }
  if (searchType === 'swisscovery') {
    searchForm.action = swisscoverySearchConfiguration['swisscoverySearchEndpoint']
  }
}

/**
 * Set Login link if not set by counter page settings
 * @type {HTMLElement}
 */
const swisscoveryLoginLink = document.getElementById('swisscovery-login-link');
if (swisscoveryLoginLink) {
  const vidInStorage = new URLSearchParams(swisscoverySearchConfiguration['swisscoverySearchEndpoint'].split("?")[1]).get("vid");
  const vidInLink = new URLSearchParams(swisscoveryLoginLink.href.split("?")[1]).get("vid");
  if(vidInLink === '') {
    swisscoveryLoginLink.href = 'https://rzs.swisscovery.org/discovery/login?vid=' + vidInStorage + '&lang=de';
  }
}

/**
 * Swisscovery search link in infobox of search results
 */
const swisscoveryInfobox = document.getElementById('swisscovery-infobox');
if(swisscoveryInfobox !== null) {

  const urlParams = new URLSearchParams(swisscoverySearchConfiguration['swisscoverySearchEndpoint'].split("?")[1]);
  const vid = urlParams.get("vid");
  const tab = urlParams.get("tab");

  // Update the search link in the infobox
  const swisscoveryLink = document.getElementById('swisscovery-infobox-link');
  const searchTerm = swisscoveryLink.dataset.query;
  swisscoveryLink.href = swisscoverySearchConfiguration['swisscoverySearchEndpoint'] + searchTerm;

  let swisscoveryHitCount = 0;
  const hitInfoText = document.getElementById('swisscovery-hit-info');

  fetch(`/api/primo-result-count/${vid}/${tab}/${searchTerm}`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(jsonResult => {
      swisscoveryHitCount = jsonResult.total;
      if(swisscoveryHitCount > 0) {
        swisscoveryInfobox.classList.remove('hidden');
        const hitInfoCount = document.getElementById('swisscovery-hit-count');
        hitInfoCount.textContent = swisscoveryHitCount.toLocaleString("de-CH");
        hitInfoText.classList.remove('hidden');
      }
    })
    .catch(error => console.error(error));
}

/**
 * To avoid constructing a form  for Swisscovery with many hidden parameters, we don't use the default submit and redirect to the result
 */
searchForm.addEventListener("submit", (event) => {
  if (searchForm.dataset.searchType === 'swisscovery') {
    event.preventDefault();
    const searchQuery = searchForm.querySelector('[name="swisscovery__query"]').value;
    const targetUri = searchForm.action + searchQuery;
    window.open(targetUri, '_blank');
  }
})


// Source: https://stackoverflow.com/a/15724300
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}


document.addEventListener("DOMContentLoaded", () => {
  new ContentSuggestions();
  new CounterPageSelection();
  new ImageLightbox();
  getScrollbarWidth();
  setSearchFocus();
});

document.addEventListener("ContentSuggestionsLoaded", () => {
  resizeInit();
});
